<ng-container *transloco="let t">
  <ld-base-modal [title]="documentName()" [size]="'large'" (closeModal)="onClose()">
    <div modal-content>
      @if (isLoading()) {
        <div class="absolute inset-0 flex items-center justify-center bg-white">
          <div class="flex flex-col items-center gap-4">
            <mat-spinner diameter="48"></mat-spinner>
            <p class="font-dm text-sm text-ld-neutral-500">{{ t('modalsDocumentViewerLoading') }}</p>
          </div>
        </div>
      }

      @if (hasError()) {
        <div class="absolute inset-0 flex items-center justify-center bg-white">
          <div class="flex flex-col items-center gap-4 text-center px-6">
            <div class="size-16 rounded-full bg-red-100 flex items-center justify-center">
              <img [src]="errorIcon" alt="Error" class="w-8 h-8" />
            </div>
            <h3 class="font-dm text-lg font-semibold text-ld-neutral">{{ t('modalsDocumentViewerErrorTitle') }}</h3>
            <p class="font-dm text-sm text-ld-neutral-500">{{ t('modalsDocumentViewerErrorMessage') }}</p>
            <button type="button" class="btn-primary-ld-purple" (click)="onClose()">
              {{ t('commonAriaClose') }}
            </button>
          </div>
        </div>
      }

      <iframe
        id="document-viewer-iframe"
        [src]="safeUrl()"
        class="w-full h-full border-0"
        [class.invisible]="isLoading() || hasError()"
        (load)="onIframeLoad()"
        (error)="onIframeError()"
        title="Document Viewer"
      ></iframe>
    </div>
    <div modal-footer>
      <button id="document-viewer-done-btn" type="button" class="btn-primary-ld-purple" (click)="onClose()">
        {{ t('commonButtonsDone') }}
      </button>
    </div>
  </ld-base-modal>
</ng-container>
